<template>
  <component
  :is="typeComponent"
  :item="item"
  @on-del="handleDel"
  @on-save="handleSave" />
</template>

<script>
import _ from 'lodash'
import {
  ItemNumber,
  ItemProcStartUser,
  ItemSelect,
  ItemRadio,
  ItemRole,
  ItemOrg
} from './index'

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ItemNumber,
    ItemProcStartUser,
    ItemSelect,
    ItemRadio,
    ItemRole,
    ItemOrg
  },
  computed: {
    typeComponent() {
      const {
        dataType
      } = this.item
      return `Item${_.upperFirst(dataType)}`
    }
  },
  methods: {
    handleDel(item) {
      this.$emit('on-del', item)
    },
    handleSave(item) {
      this.$emit('on-save', item)
    }
  }
}
</script>
